import React from "react";
import Link from "next/link";
import { CALENDLY_URL } from "@/common/site.config";
import { StatRow } from "./landing/landing-ui";

const TRUST_STATS = [
  { value: "Production systems", label: "Built for live operations" },
  { value: "Agents & LLMs", label: "Designed around real work" },
  { value: "Global delivery", label: "US · EU · APAC" },
];

const HeroSection = () => {
  return (
    <section className="landing-hero relative flex items-center justify-center overflow-hidden">
      <div className="landing-hero-glow" aria-hidden />
      <div className="landing-hero-grid" aria-hidden />

      <div className="container relative z-20 max-w-7xl">
        <div className="page-hero-animate relative mx-auto flex max-w-5xl flex-col items-center text-center">
          <p className="syne-font mb-5 text-2xl font-bold tracking-tight text-[#1c8c80] sm:text-3xl md:text-4xl">
            Nivalabs.ai
          </p>

          <h1 className="syne-font text-3xl font-bold leading-[1.15] tracking-tight text-ink sm:text-4xl md:text-5xl lg:text-6xl xl:text-[4.5rem]">
            AI systems that fit
            <br className="hidden sm:block" />
            <span className="text-main"> how your business runs</span>
          </h1>

          <p className="mb-0 mt-5 max-w-3xl text-[1.0625rem] font-normal leading-relaxed text-ink-muted md:text-lg">
            We design and ship AI agents, LLM applications, and workflow
            automation that connect to your tools, data, and teams. Clear
            scope. Reliable delivery. Systems you can operate.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <Link
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="landing-btn-primary"
            >
              Talk to an architect
            </Link>

            <Link href="/contact" className="landing-btn-secondary">
              Discuss your use case
            </Link>
          </div>

          <StatRow items={TRUST_STATS} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
